// tslint:disable

import * as _ from 'lodash';
import * as React from 'react';
import { Field } from '../libs/form.lib';
import { BaseField } from '../libs/input-base';

export class JsonField extends BaseField<any> {
    public field: Field = this.props.field;
    public schema: any = this.props.schema || {};

    public state: any = {
        initialized: false,
        simpleFields: [],
        errors: false
    };

    componentDidMount() {
        this.initailizeSchema(this.field.getValue() || {});

        this.field.onValueChanges$.subscribe((value: any) => {
            this.initailizeSchema(value);
        });

        this.field.form.onNEVERUSEONLYFORTHESPECIALHiddenValueChanges$.subscribe((args: any[]) => {
            if (!args[1]) {
                this.processValidators();
            }
        });
    }

    private initailizeSchema(value: any) {
        this.field.registerField();
        this.field.setValue(value, true, false);


        this.setState({
            initialized: true,
            simpleFields: _.map(this.schema, (template: any, key: string) => {
                const f = new Field({
                    property: key,
                    title: key
                });
                if (_.get(value, key)) {
                    f.setValue(_.get(value, key), true, true);

                }
                f.onValueChanges$.subscribe(() => this.onChangeField());
                return template(f);
            })
        });
    }

    public onChangeField() {
        this.setState({errors: []});

        const overallValue: any = _.map(this.state.simpleFields, (comp: any) => ({
            value: _.get(comp, 'props.field.value'),
            key: _.get(comp, 'props.field.property'),
        }));

        let resultObject = {};

        overallValue.forEach((obj: any) => {
            resultObject[obj.key] = obj.value;
        });

        this.field.setValue(resultObject, false, false);
    }

    public processValidators() {
        // Do something with validators :D
    }

    render() {
        return (
            <div className="w-100 panel">
                <div className="panel-heading">{this.props.title || 'JSON FIELD'}</div>
                <div className="panel-body">
                    {this.state.initialized && _.map(this.state.simpleFields, (template: any, key: string) => {
                        return <div key={key}>{template}</div>;
                    })}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/fields/json.field.tsx